export default "__VITE_ASSET__BnYaZBhA__"